import joi from "joi";

import {equipmentEndpointSchema, serviceUidFieldSchema} from "./common";

export const deconstructionOrderSchema = joi.object({
  activeEquipmentEndpoint: equipmentEndpointSchema,
  serviceUid:              serviceUidFieldSchema,
});
